import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { unbookmarkObject } from 'features/bookmark/services';
import type { CommentBookmarkDeleteAction } from '../../types';
import { useUpdateCommentBookmark } from '../hooks/useUpdateCommentBookmark';

export const useUnbookmarkCommentMutation = () => {
  const updateCommentBookmark = useUpdateCommentBookmark();

  return useMutation<unknown, CommentBookmarkDeleteAction>({
    mutationFn: async ({ id }) => unbookmarkObject(id),
    onSuccess(_, params) {
      updateCommentBookmark(params);
    },
  });
};
